import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import type { PaperKeys } from "@/types/concept";

export const paperKeysKey = (conceptId: string) => ["paper-keys", conceptId] as const;

/** S2 ids + lower-cased DOIs already in the concept, for client-side
 *  "already in the concept" checks. Invalidated wherever papers are added. */
export function usePaperKeys(conceptId: string) {
  return useQuery({
    queryKey: paperKeysKey(conceptId),
    queryFn: () => apiClient.get(`api/concepts/${conceptId}/papers/keys`).json<PaperKeys>(),
    enabled: !!conceptId,
  });
}
